var _path, _path2, _path3, _path4, _path5, _path6, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 257,
    viewBox: "0 0 286 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.005 283.025L205.969 37.9986C209.043 20.4712 190.769 6.68217 175.85 15.2813L-18.6292 127.388",
    stroke: "url(#paint0_linear_919_121821)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.76 283.028L156.419 121.189C157.643 105.24 141.802 93.3464 127.763 99.6572L-16.637 164.282",
    stroke: "url(#paint1_linear_919_121821)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.491 281.697L83.6267 191.454C81.2397 180.386 70.8902 173.008 60.2026 174.747L-17.3027 187.183",
    stroke: "url(#paint2_linear_919_121821)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M195.261 13.9656C196.807 12.9813 198.859 13.4368 199.843 14.9831C200.828 16.5294 200.372 18.5809 198.826 19.5653C197.279 20.5497 195.228 20.0941 194.244 18.5478C193.259 17.0015 193.715 14.95 195.261 13.9656Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0125 252.934C100.559 251.95 102.61 252.406 103.595 253.952C104.579 255.498 104.123 257.55 102.577 258.534C101.031 259.518 98.9794 259.063 97.995 257.517C97.0106 255.97 97.4662 253.919 99.0125 252.934Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M152.115 155.356C153.662 154.372 155.713 154.827 156.698 156.374C157.682 157.92 157.227 159.972 155.68 160.956C154.134 161.94 152.082 161.485 151.098 159.938C150.114 158.392 150.569 156.341 152.115 155.356Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.479,
    y: 145.609,
    width: 5.19947,
    height: 20.2202,
    transform: "rotate(66.402 20.479 145.609)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_919_121821",
    x1: 279.388,
    y1: 242.829,
    x2: 34.3943,
    y2: 148.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00520833,
    stopColor: "#FFBA94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8430E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_919_121821",
    x1: 206.783,
    y1: 261.952,
    x2: 29.1049,
    y2: 191.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00520833,
    stopColor: "#FFBA94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8430E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_919_121821",
    x1: 114.08,
    y1: 279.421,
    x2: 4.50883,
    y2: 254.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00520833,
    stopColor: "#FFBA94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8430E1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVector);
export default __webpack_public_path__ + "static/media/logo-vector.9afe26ad98cec8b1da81d70399c7adfc.svg";
export { ForwardRef as ReactComponent };